import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { FileUp } from "lucide-react";
import { Link } from "react-router-dom";

export default function ImportReport() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Import Credit Report</h1>
      <Card className="bg-zinc-900 border-zinc-800">
        <CardContent className="py-12 text-center">
          <FileUp className="h-16 w-16 mx-auto text-zinc-600 mb-4" />
          <p className="text-zinc-400 mb-4">To import a credit report, start a dispute wizard for a client</p>
          <Link to="/clients">
            <Button className="bg-orange-500 hover:bg-orange-600">Go to Clients</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
